import React from 'react';
import PropTypes from 'prop-types';
import './forminputs.css';

const RenderRadioButtonError = ({ className, meta: { touched, error } }) =>
  touched && error ? (
    <span className={'radio-button-error ' + (className ? className : '')}>{error}</span>
  ) : (
    false
  );

RenderRadioButtonError.propTypes = {
  meta: PropTypes.any,
  className: PropTypes.string
};

export default RenderRadioButtonError;
